import axios from '@/libs/axios';
import {stringCompare} from "@/owms/utils/comperator";

export default {
    namespaced: true,
    state: {
        activeClubs: [],
        clubLeagues: {},
    },
    getters: {
        async activeClubs(state) {
            if(state.activeClubs.length === 0) {
                try {
                     const clubs = (await axios.get('/auth/clubs/active')).data;

                    state.activeClubs = clubs.sort((c1, c2) => stringCompare(c1.name, c2.name));
                }
                catch (e) {
                    console.log(e);
                    state.activeClubs = [];
                }
            }
            return state.activeClubs;
        },
    },
    mutations: {
        SET_CLUB_LEAGUES(state, clubLeagues) {
            state.clubLeagues = clubLeagues;
        },
    },
    actions: {
        async clubInformation ({}, clubId) {
            try {
                return (await axios.get(`/auth/club-information/${clubId}`)).data.data || [];
            }
            catch (e) {
                console.log(e);
                return [];
            }
        },
        async definedContacts ({}, clubId) {
            try {
                return (await axios.get(`/auth/club-information/contacts/${clubId}`)).data.data || [];
            }
            catch (e) {
                console.log(e);
                return [];
            }
        },
        async pendingOrActiveContacts ({}, clubId) {
            try {
                return (await axios.get(`/auth/club-information/pending-active-contacts/${clubId}`)).data.data || [];
            }
            catch (e) {
                console.log(e);
                return [];
            }
        },
        async storeContacts ({}, {clubId, contacts}) {
            try {
                return (await axios.post(`/auth/club-information/pending-active-contacts/${clubId}`, {contacts: contacts})).data.data || null;
            }
            catch (e) {
                console.log(e);
                return [];
            }
        },
        async storeInformation ({}, data) {
            try {
                return (await axios.post(`/auth/club-information/update-or-create`, data)).data.data || null;
            }
            catch (e) {
                console.log(e);
                throw e;
            }
        },
        async confirmInformation ({}, data) {
            try {
                return (await axios.post(`/auth/club-information/confirm/${data.id}`, data)).data.data || null;
            }
            catch (e) {
                console.log(e);
                throw e;
            }
        },
        async exportPlayers ({}, clubId) {
            const res = await axios.get(`/auth/clubs/${clubId}/players-export`, {responseType: 'blob'});
            const url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'igralci.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async clubLeagues (context, clubId) {
            if(!context.state.clubLeagues.hasOwnProperty(clubId) || (new Date() - context.state.clubLeagues[clubId].readAt) > 10 * 60 * 1000) {
                try {
                    const leagues = (await axios.get(`/auth/clubs/${clubId}/leagues`)).data || [];

                    context.commit('SET_CLUB_LEAGUES', {
                        ...context.state.clubLeagues,
                        [clubId]: {
                            readAt: new Date(),
                            leagues: leagues,
                        }
                    });
                }
                catch (e) {
                    console.log(e);
                    context.commit('SET_CLUB_LEAGUES', {
                        ...context.state.clubLeagues,
                        [clubId]: {
                            readAt: new Date('1990-01-01'),
                            leagues: [],
                        }
                    });
                }
            }

            return context.state.clubLeagues[clubId].leagues;
        }
    },
}
